import { BenefitsType } from "../../interfaces/benefits/Benefits.type";
import Benefits from "./Benefits";

export default function BenefitsContainer({
    items,
}: {
    items: BenefitsType[];
}) {
    const item = items[0];
    return (
        <div className={`vas-w-100`}>
            <Benefits item={item} />
        </div>
    );
}
